/**
  * Organization: Revzoom India Pvt Ltd.
  * User: om
  * Date: 05/01/17
  * Time: 11:40 PM
  */
import _ from 'lodash';
import Collection from "./Collection";
import HashSetIterator from "./HashSetIterator";

export default class HashSet extends Collection {

  /**
   * Takes either collection or array.
   * @param collection{collectionOrArray} Optional collection to copy
   */
  constructor(collectionOrArray = null) {
    super();

    /**
     * @type {Object}
     * @private
     */
    this._data = {};

    /**
     * @type {number}
     * @private
     */
    this._size = 0;
    if (collectionOrArray) {
      if (Array.isArray(collectionOrArray)) {
        this.addArray(collectionOrArray);
      } else {
        this.addAll(collectionOrArray);
      }
    }
  }

  /**
   *
   * @param item
   * @returns {boolean}
   */
  contains(item) {
    return !!this._data[item];
  }

  /**
   *
   * @param item
   * @returns {*}
   */
  add(item) {
    if (item == null) { // double equals to check for both null and undefined
      return null;
    }

    const oldItem = this.remove(item);
    this._data[item] = item;
    this._size = this._size + 1;
    return oldItem;
  }

  /**
   *
   * @param item
   * @returns {*}
   */
  remove(item) {
    const present = this._data[item];
    if (present !== undefined) {
      delete this._data[item];
      this._size = this._size - 1;
    }
    return present ? item : null;
  }

  /**
   *
   * @param collection {Collection}
   */
  addAll(collection) {
    const iterator = collection.iterator();
    while (iterator.hasNext()) {
      const next = iterator.next();
      if (!this.contains(next))
        this.add(next);
    }
  }

  addArray(array) {
    if (array) {
      array.forEach(function (element) {
        this.add(element);
      }, this);
    }
  }

  /**
   * clears the whole HashSet.
   */
  clear() {
    this._data = {};
    this._size = 0;
  }

  /**
   * returns size of the HashSet.
   * @returns {number|*}
   */
  size() {
    return this._size;
  }

  /**
   * returns the hashSet in form of Array.
   * @returns {Array}
   */
  toArray() {
    return this._data ? _.values(this._data) : [];
  }

  /**
   * returns iterator to iterate upon the HashSet.
   * @returns {HashSetIterator}
   */
  iterator() {
    return new HashSetIterator(this);
  }
}